export default "__VITE_ASSET__CqfvDOl3__"